module.exports = __webpack_public_path__ + "img/page-06.7669cc62.jpg";